function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "facebook_svg__a",
  x1: -277.375,
  x2: -277.375,
  y1: 406.602,
  y2: 407.573,
  gradientTransform: "matrix(16 0 0 -15.91112 4446 6484.934)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#0062e0",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#19afff",
    stopOpacity: 1
  }
}))), /*#__PURE__*/React.createElement("path", {
  d: "M6.68 15.922C2.879 15.238 0 11.96 0 8c0-4.398 3.602-8 8-8s8 3.602 8 8c0 3.96-2.879 7.238-6.68 7.922l-.441-.363H7.12Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#facebook_svg__a)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.121 10.238 11.481 8H9.358V6.441c0-.64.243-1.12 1.2-1.12h1.043V3.28c-.563-.082-1.204-.16-1.762-.16-1.84 0-3.121 1.117-3.121 3.117V8h-2v2.238h2v5.64a7.2 7.2 0 0 0 2.64 0v-5.64Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}));
export default SvgFacebook;